export function getUniqueId() {
  return "_" + Math.random().toString(36).substr(2, 9);
}

export { default as dateUtil } from "./date.util";
